import React, { useState } from 'react';
import { Box, useTheme } from '@mui/material';
import Navbar from '../common/Navbar';
import Sidebar from '../common/Sidebar';
import { ProfileModal } from '../../features/auth/components/ProfileModal';
import { useAuth } from '../../features/auth';
import SessionTimeoutWarning from '../../features/auth/components/SessionTimeoutWarning';

const drawerWidth = 0; // Re-enabling drawerWidth properly

const HomeLayout = ({ children }) => {
  const [openProfile, setOpenProfile] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const { sessionExpiresAt, hasRefreshToken, logout } = useAuth();
  const theme = useTheme();

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  return (
    <Box sx={{ display: 'flex', minHeight: '100vh', bgcolor: '#020617' }}>

      {/* Top Navbar */}
      <Navbar onDrawerToggle={handleDrawerToggle} onOpenProfile={() => setOpenProfile(true)} />

      <Sidebar
        onOpenProfile={() => setOpenProfile(true)}
        mobileOpen={mobileOpen}
        onDrawerToggle={handleDrawerToggle}
      />

      <Box
        component="main"
        sx={{
          flexGrow: 1,
          p: { xs: 2, sm: 3 },
          pt: { xs: 10, md: 12 }, // Spacing for the top Navbar
          ml: {
            xs: 0,
            md: `${drawerWidth}px`
          },
          width: {
            xs: '100%',
            md: `calc(100% - ${drawerWidth}px)`
          },
          transition: theme.transitions.create(['margin', 'width'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
          }),
          bgcolor: '#020617',
          color: '#F9FAFB',
          minHeight: '100vh',
          overflowX: 'hidden'
        }}
      >
        {children}
      </Box>

      <ProfileModal open={openProfile} onClose={() => setOpenProfile(false)} />

      {/* Session Expiration Warning */}
      <SessionTimeoutWarning
        sessionExpiresAt={sessionExpiresAt}
        hasRefreshToken={hasRefreshToken}
        onLogout={logout}
      />
    </Box>
  );
};

export default HomeLayout;